import React from 'react';

import Link from '../Link';

export const Copy = (
  <p>
    Volg jouw favoriete BNNVARA-titel(s) dan kunnen we je meer geven wat je echt
    interesseert en krijg je een berichtje zodra er een nieuw artikel of video
    online komt.{' '}
    <Link
      disableNextLink
      href="/wijzijnvoor-jijook"
      category="header"
      action="click"
      label="wijzijnvoor-jijook"
    >
      Lees verder.
    </Link>
  </p>
);
